module.exports = __webpack_public_path__ + "static/ef8c6d07ee066b8aef356a5f7427116da5041552dc5dcd802f3abf5a39704a86-5af326f9e0574941ff2a0203edeb9dfe.jpeg";